export default __webpack_public_path__ + "static/media/history-img.21fe2f43.png";